import { render, staticRenderFns } from "./relatedContract.vue?vue&type=template&id=fd478e34"
import script from "./relatedContract.vue?vue&type=script&lang=js"
export * from "./relatedContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports